import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { IconButton } from '../../atoms/buttons';
import { spaceSizes } from '@nauto/core';

import { colors } from '../../styles';
import cx from 'classnames';

export interface Props {
  className?: string;
  onChange?: (search: string) => void;
  value?: string;
  cellWidth?: number;
}

export interface State {
  open: boolean;
  value: string;
}

export class TableSearch extends React.Component<Props, State> {
  state = { open: !!this.props.value, value: this.props.value };

  private inputRef;

  assignInputRef = el => (this.inputRef = el);

  toggle = (e: React.MouseEvent<HTMLElement>) => {
    const { open } = this.state;
    if (!open) {
      this.inputRef.focus();
      this.setState({ open: true, value: this.props.value });
    } else {
      this.dismiss();
    }
  };

  dismiss = () => {
    const { onChange } = this.props;

    this.inputRef.blur();
    onChange('');
    this.setState({ open: false, value: '' });
  };

  noPropagation = e => e.stopPropagation();

  onTextChange = e => {
    const { onChange } = this.props;
    const { value } = e.target;
    onChange(value);
    this.setState({ value });
  };

  public render() {
    const { open, value } = this.state;
    const { className } = this.props;

    return (
      <div
        className={cx(`${className} table-search`, { open })}
        onClick={this.noPropagation}
      >
        <div className="input-wrapper">
          <IconButton
            className="toggle"
            onClick={this.toggle}
            icon="search"
            baseColor={open ? colors.green500 : colors.grey900}
            size="sm"
          />
          <input
            type="text"
            onChange={this.onTextChange}
            ref={this.assignInputRef}
            value={value}
          />
          <IconButton
            onClick={this.dismiss}
            className="dismiss"
            icon="closeCircle"
            baseColor={colors.grey200}
            activeColor={colors.grey400}
            size="sm"
          />
        </div>
      </div>
    );
  }
}

export default styled(TableSearch)`
  width: 48px;
  height: 32px;
  position: relative;
  z-index: 1;
  button {
    border: none;
    background: none;
    cursor: pointer;
    height: 32px;
  }
  button.toggle {
    width: 36px;
    min-width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  button.dismiss {
    width: 30px;
    display: flex;
    align-items: center;
  }

  input {
    border: none;
    width: ${({ cellWidth }) => cellWidth - spaceSizes.xxxl}px;
  }
  input:focus {
    outline: none;
  }

  .input-wrapper {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: left;
    left: 0rem;
    top: 0;
    width: 36px;
    overflow-x: hidden;
    display: flex;
    flex-flow: row;
    background-color: transparent;
    border-radius: 1000px;
    border: 1px solid transparent;
  }
  &.open {
    .input-wrapper {
      transition: all 200ms linear;
      transition-property: border-color, background-color;
      background-color: white;
      width: ${({ cellWidth }) => cellWidth - spaceSizes.xs}px;
      border-color: ${colors.grey500};
    }
  }
  @media print {
    display: none;
  }
`;
